import { render } from "./ClientAnnouncements.vue?vue&type=template&id=fd9837ee"
import script from "./ClientAnnouncements.vue?vue&type=script&lang=js"
export * from "./ClientAnnouncements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__